import React, { useState, useEffect } from "react";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    gmail: "",
    companyName: "",
    messages: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      contactUsData: {
        email: formData.gmail,
        name: formData.name,
        message: formData.messages,
        company: formData.companyName,
      },
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://us-west1-slashstar-co.cloudfunctions.net/verifyCapchaInContactUs",
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setShowSnackbar(true);
      setFormData({
        name: "",
        gmail: "",
        companyName: "",
        messages: "",
      });

      setTimeout(() => {
        setShowSnackbar(false);
      }, 5000);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="contact-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeInUp" data-wow-delay="0.3s">
            <h1>Contact Us</h1>
          </div>
        </div>
      </section>

      <section className="sub-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>CONTACT US</span>
          </div>
          <div className="title row wow fadeInUp">
            <div className="col col-6">
              <h2>
                We would <span className="gradient-text">love</span> to hear
                from you
              </h2>
            </div>
            <div className="col col-6">
              <p>
                Get in touch with us today to discuss your software development
                and outsourcing needs. We're committed to excellent customer
                service and helping you achieve your goals. Contact us for a
                consultation or to learn more about our services. We're excited
                to hear from you!
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col col-6 wow fadeInUp">
              <h3>Let's Talk About Your Project</h3>
              <form className="form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder=" "
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  <label>Name</label>
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="gmail"
                    id="gmail"
                    placeholder=" "
                    className="form-control"
                    required
                    value={formData.gmail}
                    onChange={handleChange}
                  />
                  <label>Email</label>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="companyName"
                    id="companyName"
                    placeholder=" "
                    className="form-control"
                    value={formData.companyName}
                    onChange={handleChange}
                  />
                  <label>Company</label>
                </div>
                <div className="form-group form-textarea">
                  <textarea
                    type="text"
                    name="messages"
                    id="messages"
                    placeholder=" "
                    className="form-control"
                    value={formData.messages}
                    onChange={handleChange}
                  ></textarea>
                  <label>Your message</label>
                </div>

                <div className="form-btn sidebar-btn btn-padding">
                  <button
                    className={`btn btn-shadow ${isSubmitting ? "loading" : ""}`}
                    type="submit"
                    id="btn"
                    disabled={isSubmitting}
                  >
                    Submit
                  </button>
                </div>
                <div
                  id="snackbar"
                  className={showSnackbar ? "show" : ""}
                >
                  Your request has been submitted successfully. <br />
                  We will reach out to you soon.
                </div>
              </form>
              <span className="outline"></span>
            </div>
            <div className="col col-6 wow fadeInUp">
              <h3>Our Offices</h3>
              <div className="address">
                <div className="office">
                  <h3>Groton, USA</h3>
                  <p>
                    360, Route 12,
                    <br />
                    Groton, CT 06340
                  </p>
                  <p>
                    Email :{" "}
                    <a
                      href="mailto:info@slashstar.co"
                      className="link"
                      data-cursor="pointer"
                    >
                      info@slashstar.co
                    </a>
                  </p>
                </div>
                <div className="office">
                  <h3>Surat, India</h3>
                  <p>
                    3002, Silver Business Point,
                    <br />
                    Uttran, Surat, GJ 394105
                  </p>
                  <p>
                    Email :{" "}
                    <a
                      href="mailto:info@slashstar.co"
                      className="link"
                      data-cursor="pointer"
                    >
                      info@slashstar.co
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
